function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M52.8758 33.5932V31.1723C52.8758 30.7227 52.1188 30.2936 50.7595 29.9067L50.7922 26.8935C50.7923 22.2518 49.3521 17.7222 46.667 13.9184C43.9818 10.1146 40.1813 7.22051 35.7804 5.62813L35.6833 5.02398C35.6332 4.70102 35.4917 4.39876 35.2752 4.1522C35.0588 3.90564 34.7763 3.72488 34.4604 3.63086C30.2411 2.40365 25.7547 2.40365 21.5355 3.63086C21.2187 3.72393 20.9352 3.90415 20.7177 4.15057C20.5003 4.39699 20.3579 4.69948 20.3071 5.0229L20.2144 5.58598C15.7867 7.16335 11.9584 10.0562 9.25211 13.8696C6.54582 17.6829 5.09351 22.2308 5.09347 26.8924V29.9186C3.75276 30.3044 3.00659 30.7292 3.00659 31.1755V33.5965C2.98522 33.7383 3.01621 33.883 3.09386 34.0039C3.76082 33.5106 4.52672 33.1645 5.34002 32.9891C7.41259 32.4889 9.51926 32.1392 11.6432 31.9429C12.2387 31.8758 12.8418 31.9354 13.4122 32.1177C13.9826 32.2999 14.5071 32.6007 14.9508 32.9999C16.5918 34.4874 18.7353 35.3125 20.9595 35.3128H34.923C37.1474 35.3128 39.2912 34.4872 40.9316 32.9988C41.3744 32.5977 41.8985 32.2949 42.4689 32.1105C43.0393 31.9262 43.6429 31.8646 44.2392 31.9299C46.3627 32.1249 48.469 32.4731 50.5413 32.9718C51.3121 33.1178 52.0398 33.4337 52.6708 33.8959C52.7068 33.9315 52.7493 33.9618 52.7798 33.9953C52.8585 33.8766 52.8925 33.7343 52.8758 33.5932Z",
  fill: "#FFF100"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9836 28.4985C14.9661 27.943 14.9541 27.3864 14.9541 26.8254C14.9607 18.4094 16.945 10.8613 20.2155 5.59033C15.7883 7.16727 11.9603 10.0594 9.25384 13.8719C6.54741 17.6844 5.09452 22.2315 5.09351 26.8925V29.9186C8.34031 29.1512 11.6504 28.6759 14.9836 28.4985Z",
  fill: "url(#paint0_linear_4059_11124)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M50.7902 26.8925C50.7976 21.6386 48.9533 16.547 45.5757 12.4966C47.0399 17.1319 47.7693 21.9643 47.7378 26.8212C47.7378 27.6415 47.716 28.4521 47.6778 29.2562C48.7139 29.4157 49.7402 29.6322 50.752 29.9047L50.7902 26.8925Z",
  fill: "url(#paint1_linear_4059_11124)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M50.5413 32.9806C48.4687 32.4804 46.362 32.1307 44.2381 31.9344C43.6422 31.8682 43.0389 31.9287 42.4685 32.112C41.8982 32.2952 41.3738 32.5968 40.9305 32.9968C39.2899 34.4848 37.1461 35.31 34.9218 35.3096H20.9638C18.7405 35.3092 16.5978 34.4846 14.9573 32.9979C14.5148 32.5962 13.9908 32.2928 13.4204 32.1081C12.8499 31.9234 12.2462 31.8616 11.6497 31.9268C9.52577 32.1228 7.4191 32.4721 5.3465 32.9719C4.53395 33.1496 3.76849 33.4954 3.10034 33.9868C4.1596 35.5939 14.882 37.281 27.9466 37.281C41.0112 37.281 51.7282 35.5885 52.7907 33.9879C52.7536 33.9554 52.7122 33.9241 52.6816 33.8895C52.0428 33.4369 51.3126 33.1268 50.5413 32.9806Z",
  fill: "url(#paint2_radial_4059_11124)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9391 9.81836L22.5938 18.8407L27.9391 22.1295V9.8216V9.81836Z",
  fill: "#0A0A0A"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9412 9.82153V22.1273L33.2866 18.8428L27.9412 9.82153Z",
  fill: "#4B4D4D"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9412 23.915V28.2056C28.0415 28.063 33.2866 20.6251 33.2866 20.6218L27.9412 23.915Z",
  fill: "#4B4D4D"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9411 23.9159L22.5957 20.6282L27.9411 28.2087V23.9137V23.9159Z",
  fill: "#0A0A0A"
});

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_4059_11124",
  x1: 12.6545,
  y1: 29.9186,
  x2: 12.6545,
  y2: 5.59033,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDCF00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#F0D500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#F9E500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFF100"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_4059_11124",
  x1: 48.1829,
  y1: 30.0961,
  x2: 48.1829,
  y2: 12.4966,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDCF00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#F7E100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFF100"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_4059_11124",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(5.79445 46.5389) scale(18.5398 18.4136)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#F9E500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#F0D500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EDCF00"
})));

function SvgHardhat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 41,
    viewBox: "0 0 55 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardhat);
export default __webpack_public_path__ + "static/media/hardhat.03c2b0ce.svg";
export { ForwardRef as ReactComponent };